import { render, staticRenderFns } from "./RolesComponent.vue?vue&type=template&id=5b0c45c0&"
import script from "./RolesComponent.vue?vue&type=script&lang=js&"
export * from "./RolesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports